import { Injectable, TemplateRef } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastService {
    toasts: any[] = [];

    show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
        const toast = { textOrTpl, ...options };
        this.toasts.push(toast);

        if (options.delay) {
            this.scheduleRemoval(toast, options.delay);
        }
    }

    scheduleRemoval(toast: any, delay: number) {
        if (toast.timeoutId) {
            clearTimeout(toast.timeoutId);
        }
        toast.timeoutId = setTimeout(() => this.remove(toast), delay);
    }

    pause(toast: any) {
        if (toast.timeoutId) {
            clearTimeout(toast.timeoutId);
            toast.timeoutId = null;
        }
    }

    resume(toast: any) {
        if (toast.delay && !toast.timeoutId) {
            this.scheduleRemoval(toast, toast.delay);
        }
    }

    remove(toast: any) {
        this.toasts = this.toasts.filter(t => t !== toast);
    }

    clear() {
        this.toasts = [];
    }

    success(message: string, delay = 3000) {
        this.show(message, { type: 'success', delay });
    }

    error(message: string, delay = 3000) {
        this.show(message, { type: 'error', delay });
    }

    update(message: string, delay = 3000) {
        this.show(message, { type: 'success', delay });
    }

    delete(message: string, delay = 3000) {
        this.show(message, { type: 'warning', delay });
    }
}
